import { column } from '../../lib/column';
import LocalizeKeys from "../../components/Localize/LocalizeKeys";

function columns(data) {
  return [
    column(data, 'date', { showAs: "date" }, LocalizeKeys.INVOICE_DATE),
    column(data, 'transactionCode', { showAs: "text" }, LocalizeKeys.INVOICE_TRANSACTION_CODE),
    column(data, 'concept', { showAs: "text" }, LocalizeKeys.INVOICE_CONCEPT),
    // "component": the amount is built as a node so the currency symbol sits in a fixed-width slot.
    column(data, 'amount', { showAs: "component" }, LocalizeKeys.INVOICE_TOTAL),
  ];
}

export { columns };
